export const HOTSWAP_GET_LOCATIONS_REQUEST = 'HOTSWAP_GET_LOCATIONS_REQUEST'
export function getLocationsRequest(filters) {
    return {
        type: HOTSWAP_GET_LOCATIONS_REQUEST,
        filters
    }
}

export const HOTSWAP_GET_LOCATIONS_SUCCESS = 'HOTSWAP_GET_LOCATIONS_SUCCESS'
export function getLocationsSuccess(locations) {
    return {
        type: HOTSWAP_GET_LOCATIONS_SUCCESS,
        locations
    }
}

export const HOTSWAP_GET_LOCATIONS_ERROR = 'HOTSWAP_GET_LOCATIONS_ERROR'
export function getLocationsError() {
    return {
        type: HOTSWAP_GET_LOCATIONS_ERROR
    }
}

export const HOTSWAP_GET_LOCATIONS_ADMIN_REQUEST =
    'HOTSWAP_GET_LOCATIONS_ADMIN_REQUEST'
export function getLocationsAdminRequest(filters) {
    return {
        type: HOTSWAP_GET_LOCATIONS_ADMIN_REQUEST,
        filters
    }
}

export const HOTSWAP_GET_LOCATIONS_ADMIN_SUCCESS =
    'HOTSWAP_GET_LOCATIONS_ADMIN_SUCCESS'
export function getLocationsAdminSuccess(locations) {
    return {
        type: HOTSWAP_GET_LOCATIONS_ADMIN_SUCCESS,
        locations
    }
}

export const HOTSWAP_GET_LOCATIONS_ADMIN_ERROR =
    'HOTSWAP_GET_LOCATIONS_ADMIN_ERROR'
export function getLocationsAdminError() {
    return {
        type: HOTSWAP_GET_LOCATIONS_ADMIN_ERROR
    }
}

export const HOTSWAP_GET_BY_ID_REQUEST = 'HOTSWAP_GET_BY_ID_REQUEST'
export function getHotSwapByIdRequest(id) {
    return {
        type: HOTSWAP_GET_BY_ID_REQUEST,
        id
    }
}

export const HOTSWAP_GET_BY_ID_SUCCESS = 'HOTSWAP_GET_BY_ID_SUCCESS'
export function getHotSwapByIdSuccess(hotswap) {
    return {
        type: HOTSWAP_GET_BY_ID_SUCCESS,
        hotswap
    }
}

export const HOTSWAP_GET_BY_ID_ERROR = 'HOTSWAP_GET_BY_ID_ERROR'
export function getHotSwapByIdError() {
    return {
        type: HOTSWAP_GET_BY_ID_ERROR
    }
}

export const HOTSWAP_UPDATE_REQUEST = 'HOTSWAP_UPDATE_REQUEST'
export function updateHotSwapRequest(id, payload) {
    return {
        type: HOTSWAP_UPDATE_REQUEST,
        id,
        payload
    }
}

export const HOTSWAP_UPDATE_SUCCESS = 'HOTSWAP_UPDATE_SUCCESS'
export function updateHotSwapSuccess(updatedHotswap) {
    return {
        type: HOTSWAP_UPDATE_SUCCESS,
        updatedHotswap
    }
}

export const HOTSWAP_UPDATE_ERROR = 'HOTSWAP_UPDATE_ERROR'
export function updateHotSwapError() {
    return {
        type: HOTSWAP_UPDATE_ERROR
    }
}

export const SET_SELECTED_HOTSWAP_LOCATIONS = 'SET_SELECTED_HOTSWAP_LOCATIONS'
export function setSelectedHotSwapLocations(response) {
    return {
        type: SET_SELECTED_HOTSWAP_LOCATIONS,
        response
    }
}
